/**
 * WonderLabs Swan workspace policy.
 *
 * Keep the activity and the conversation side by side on desktop, including
 * short desktop viewports at 150% Windows display scaling. A learner may
 * explicitly expand the conversation; narrow phones need a focused reading
 * workspace because two columns would not be usable.
 *
 * Do not derive focus from the height or the WonderLabs density profile.
 * Browser zoom remains under the user's control and regular layout reflows.
 */
export function shouldFocusSwanConversation({ width, unified, open, expanded = false }) {
  if (!unified || !open) return false;
  return Boolean(expanded) || Number(width) < 760;
}
